import axios from "axios";
import { API_BASE_URL1 } from "../../Services/baseApiUrl";
import axiosInstance from "../../../Hooks/axoisInstance";

const getToken = () => {
  return localStorage.getItem("token");
};

export const AllPrimaryDeploymentReport = async (StartDate, endData, vehicleNumber, ZoneId) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `RawReport/GetAllPrimaryDeploymentTransaction?startDate=${StartDate}&endDate=${endData}&VehicleNumber=${vehicleNumber}&ZoneId=${ZoneId}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
    );
    return response;
  } catch (error) {
    throw error;
  }
};